<template>
    <!-- Footer -->
    <div class="footer">
        <div class="row justify-content-between align-items-center">
            <div class="col d-flex align-items-center">
                <p class="fs-6 mb-0">&copy; <span class="d-none d-sm-inline-block">{{year}} Magico</span></p>
                <color-switcher class="ms-2 d-inline-block" v-if="!isAdmin"></color-switcher>
            </div>
            <!-- End Col -->
            <div class="col-auto">
                <div class="d-flex justify-content-end">
                    <!-- List Separator -->
                    <ul class="list-inline list-separator">
                        <li class="list-inline-item">
                            <a class="list-separator-link" target="_blank" href="/app.apk">Aplikacja</a>
                        </li>
                        <li class="list-inline-item">
                            <a class="list-separator-link" href="https://google.pl">Pomoc</a>
                        </li>
                        <li class="list-inline-item">
                            <a class="list-separator-link" href="https://magico.pl">Magico.pl</a>
                        </li>
                        <li class="list-inline-item">
                            <!-- Keyboard Shortcuts Toggle -->
                            <button class="btn btn-ghost-secondary btn btn-icon btn-ghost-secondary rounded-circle" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasKeyboardShortcuts" aria-controls="offcanvasKeyboardShortcuts">
                                <i class="bi-command"></i>
                            </button>
                            <!-- End Keyboard Shortcuts Toggle -->
                        </li>
                    </ul>
                    <!-- End List Separator -->
                </div>
            </div>
            <!-- End Col -->
        </div>
        <!-- End Row -->
    </div>
    <!-- End Footer -->
</template>
<script>
import ColorSwitcher from './ColorSwitcher.vue'

export default {
    name: 'Footer',
    components: { ColorSwitcher },
    computed: {
        isAdmin: function() {
            return ['owner', 'manager'].includes(this.$store.getters['app/role'])
        },
    },
    data: function() {
        return {
            isShow: true,
            year: (new Date).getFullYear(),
        }
    },
    methods: {

    },
    mounted() {

    }
}
</script>